<template>
    <el-dialog
    :show-close="false"
        :title="title"
        :visible="disableDialog"
        width="414px">
      <span style="padding-left:30px;">{{content}}</span>
        <span slot="footer" class="dialog-center">
            <el-button type="primary" @click="onSubmit">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
  props: ['title', 'content'],
  data () {
    return {
      disableDialog: false
    }
  },
  methods: {
    // 审核不通过弹窗初始化
    onInitial () {
      this.disableDialog = true
    },
    // 确定
    onSubmit () {
      this.disableDialog = false
      this.$emit('onRejectDialog')
    }
  }
}
</script>
